export const ConfirmShowingValidationSchema = {
    reject_reason: [
        { rule: "required", message: "Reason required" },
    ]
}